export type TestimonialItem = {
  rating: number;
  name: string;
  country: string;
  description: string;
};

export const TestimonialData: TestimonialItem[] = [
  {
    rating: 5,
    name: "Joshua Silverman",
    country: "United States",
    description:
      "BIGELEMENT INFOTECH delivered our web development project ahead of schedule with exceptional quality. Their team's expertise in React and modern web technologies resulted in a solution that improved our site performance by 50%. Highly professional and reliable.",
  },
  {
    rating: 5,
    name: "Kyle Nguyen",
    country: "United States",
    description:
      "Their UI/UX design team transformed our website with a user-centric approach. They were incredibly patient and responsive to feedback, making multiple iterations until we achieved the perfect design. The result exceeded our expectations and boosted user satisfaction significantly.",
  },
  {
    rating: 5,
    name: "Jasim Khumi",
    country: "United Arab Emirates",
    description:
      "Expert in .NET framework and Microsoft SQL Server. They truly understand client requirements and deliver scalable, secure solutions on time. Our enterprise application built with their team has been running flawlessly for over two years with excellent performance.",
  },
  {
    rating: 5,
    name: "Craig Nelson",
    country: "United States",
    description:
      "One of the best full-stack development teams I've worked with. Their developers handle complex tasks independently with minimal oversight, delivering clean, maintainable code. Their expertise in NodeJS, React, and cloud technologies made our product launch seamless. Will definitely work with them again.",
  },
  {
    rating: 5,
    name: "QT Corporation",
    country: "United States",
    description:
      "Outstanding Azure DevOps expertise and cloud deployment support. They quickly resolved our CI/CD pipeline issues through proactive communication and screen-sharing sessions. Their availability and technical problem-solving skills saved us significant time and resources. Highly satisfied with their service.",
  },
  {
    rating: 5,
    name: "Hemant Patel",
    country: "United States",
    description:
      "Talented, dependable, and collaborative team that consistently delivers exceptional work. Over several years, they developed robust RESTful APIs for our mobile application, ensuring scalability and performance. Their technical skills, work ethic, and dedication make them an invaluable long-term partner.",
  },
  {
    rating: 5,
    name: "Sarah Mitchell",
    country: "United Kingdom",
    description:
      "BIGELEMENT INFOTECH transformed our web presence with their exceptional UI/UX design services. The new interface increased our conversion rate by 45% and significantly improved user engagement. Their attention to detail and data-driven approach made all the difference.",
  },
  {
    rating: 5,
    name: "David Chen",
    country: "Canada",
    description:
      "We partnered with them for our product development project, and they exceeded all expectations. From concept to launch, they delivered a scalable solution that streamlined our operations and reduced costs by 30%. Their agile methodology and transparent communication were outstanding.",
  },
  {
    rating: 5,
    name: "Maria Rodriguez",
    country: "United States",
    description:
      "Their React and NodeJS expertise helped us build a high-performance web application that handles thousands of concurrent users seamlessly. The cloud deployment on AWS was flawless, and their ongoing support has been invaluable. Highly recommend for enterprise-level projects.",
  },
  {
    rating: 5,
    name: "James Wilson",
    country: "Australia",
    description:
      "Working with BIGELEMENT INFOTECH was a game-changer for our business. They developed a custom web solution that integrated perfectly with our existing systems. The team's expertise in .NET and SQL Server ensured robust, secure, and scalable architecture. ROI was evident within months.",
  },
  {
    rating: 5,
    name: "Lisa Anderson",
    country: "United States",
    description:
      "Their UI/UX design team created an intuitive interface that our customers love. The responsive design works flawlessly across all devices, and our bounce rate dropped by 60%. Their design-to-code conversion process was smooth and efficient.",
  },
];
